import { FormEvent, useState } from "react";
import { User } from "../../../types/auth";

type LoginPageProps = {
  onLogin: (user: User) => void;
};

export default function LoginPage({ onLogin }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (username === "admin" && password === "admin") {
      onLogin({ name: "Admin", email: "admin@boticlick.com" });
      setError("");
      return;
    }

    setError("Credenciales invalidas. Usa user: admin y password: admin.");
  };

  return (
    <main className="auth-layout">
      <section className="card auth-card">
        <h1>Iniciar sesion</h1>
        <p className="subtitle">Accede a tu panel de gestion de boticlick.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="username">Usuario</label>
          <input
            id="username"
            type="text"
            placeholder="admin"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />

          <label htmlFor="password">Contrasena</label>
          <input
            id="password"
            type="password"
            placeholder="admin"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />

          {error ? <p className="error">{error}</p> : null}
          <button type="submit">Entrar</button>
        </form>
      </section>
    </main>
  );
}
